<template>
  <div
    :class="{
      'back-to-top-button': true,
      bottomTop: showButton,
      topBottom: !showButton,
    }"
  >
    <HoverComponent>
      <div class="iconbox">
        <svg-icon name="WeCom"></svg-icon>
      </div>
      <template v-slot:image>
        <div class="weCombox">
          <div>专属购车顾问</div>
          <img
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Sidebar/wecom_qrcode.webp"
            alt="Hover Image"
          />
        </div>
      </template>
    </HoverComponent>
    <HoverComponent>
      <div class="iconbox"><svg-icon name="Phone"></svg-icon></div>
      <template v-slot:image>
        <div class="servicebox">
          咨询电话：400-606-1600
        </div>
      </template>
    </HoverComponent>
    <HoverComponent ref="backtoTop">
      <div
        :class="{
          iconbox: true,
          bottomTopOpacity: showButton,
          topBottomOpacity: !showButton,
        }"
        @click="scrollToTop"
      >
        <svg-icon
          name="ChevronUp"
          :class="{ topBottomOpacity: !showButton }"
        ></svg-icon>
      </div>
      <template v-slot:image>
        <div class="servicebox">
          回到顶部
        </div>
      </template>
    </HoverComponent>
  </div>
</template>

<script>
import SvgIcon from "@components/Icon/index.vue";
import HoverComponent from "@components/HoverComponent/index.vue";
export default {
  name: "BackToTopButton",
  components: {
    SvgIcon,
    HoverComponent,
  },
  data() {
    return {
      showButton: false,
    };
  },
  mounted() {
    // this.scrollToTop()
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const screenHeight = window.innerHeight; // 屏幕高度
      this.showButton = scrollTop > screenHeight; // 根据滚动位置判断是否显示返回顶部按钮
    },
    scrollToTop(event) {
      this.$refs.backtoTop && this.$refs.backtoTop.hide();
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动到顶部
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";
.back-to-top-button {
  position: fixed;
  bottom: 0px;
  right: 16px;
  z-index: 99;

  // max-height: 0px;
  // overflow: hidden;

  @include media(
    (
      $md: (
        bottom: 16px,
        right: 16px,
      ),
    )
  );

  .iconbox {
    background-color: rgba(245, 247, 250, 0.6);
    color: #131415;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    margin-top: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;

    @include media(
      (
        $md: (
          width: 44px,
          height: 44px,
        ),
      )
    );
    cursor: pointer;
    // &:last-child {
    //   transition: height 0.3s cubic-bezier(0.39, 0.575, 0.565, 1),
    //     margin 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
    // }
    &:hover {
      background-color: #131415;
      color: #fff;
    }
    &:active {
      background-color: rgba(238, 238, 238, 0.6);
      color: #131415;
    }
    .iconHei {
      height: 48px;
      @include media(
        (
          $md: (
            width: 44px,
            height: 44px,
          ),
        )
      );
    }
    .iconboxHei {
      height: 0;
    }
  }
  .weCombox {
    background-color: #fff;
    box-shadow: 0px 8px 16px 0px rgba(19, 20, 21, 0.2);
    margin-right: 20px;
    padding: 16px 12px;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    > img {
      width: 140px;
      height: 140px;
      margin-top: 8px;
    }
  }
  .servicebox {
    background-color: #fff;
    margin-right: 20px;
    padding: 12px 24px;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    white-space: nowrap;
    box-shadow: 0px 8px 16px 0px rgba(19, 20, 21, 0.2);
  }
}
.bottomTop {
  animation: slideBottomTop 0.3s ease-in-out;
  bottom: 32px;
}
.bottomTopOpacity {
  animation: slideBottomTopOpacity 0.3s ease-in-out;
  opacity: 1;
  height: 48px;
  @include media(
    (
      $md: (
        width: 44px,
        height: 44px,
      ),
    )
  );
}
.topBottom {
  animation: slideTopBottom 0.3s ease-in-out;
  bottom: -30px;
}
.topBottomOpacity {
  animation: slideTopBottomOpacity 0.3s ease-in-out;
  opacity: 0;
}
@keyframes slideBottomTop {
  0% {
    bottom: -32px;
  }
  100% {
    bottom: 32px;
  }
}
@keyframes slideBottomTopOpacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
@keyframes slideTopBottom {
  0% {
    bottom: 32px;
  }

  100% {
    bottom: -32px;
  }
}
@keyframes slideTopBottomOpacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
